import { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import Button from "@/components/common/Button";
import TextEditor from "@/components/common/inputs/Text_Editor";
import Success from "@/components/common/alerts/Success";
import { useLoader } from "@/hooks/LoaderProvider";

const DisputeDialog = ({ isVisible, onClose }) => {
  const [disputeText, setDisputeText] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleSendReport = () => {
    onClose(); // Close dispute dialog first
    showLoader();

    // Simulate API call
    setTimeout(() => {
      hideLoader();
      setShowSuccessModal(true);
    }, 2000);
  };

  return (
    <>
      <Modal
        open={isVisible}
        onCancel={onClose}
        footer={null}
        centered
        width={600}
        closeIcon={null}
        styles={{
          body: { padding: 0 },
          content: {
            padding: 0,
            borderRadius: "16px",
            overflow: "hidden",
          },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
        }}>
        <div className="flex flex-col bg-white">
          {/* Content Area */}
          <div className="px-6 pb-6 mt-5">
            <div className="text-center mb-6">
              <h3 className="heading-regular font-bold text-primary mb-2">
                Report This Transaction
              </h3>
              <p className="text-lighterGrey text-regular">
                Enter your report reason below
              </p>
            </div>

            {/* Text Editor */}
            <TextEditor
              label="REPORT MESSAGE"
              value={disputeText}
              onChange={setDisputeText}
              placeholder="Type your dispute details here..."
              className="w-[360px] h-[139px]"
            />
          </div>

          {/* Footer */}
          <div className="w-full bg-lighterBlue p-4 flex gap-3">
            <Button
              text="CANCEL"
              color="secondary"
              className="flex-1 border border-primary"
              customBgColor="white"
              customTextColor="primary"
              onClick={onClose}
            />
            <Button
              text="SEND REPORT"
              color="primary"
              customBgColor="primary"
              customTextColor="white"
              className="flex-1"
              onClick={handleSendReport}
            />
          </div>
        </div>
      </Modal>

      {/* Success Modal */}
      <Success
        isVisible={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        header="Report Sent"
        paragraph="Your report has been successfully sent to the creator of this transaction."
        buttonText="Continue"
      />
    </>
  );
};

DisputeDialog.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default DisputeDialog;
